// Bottom cta
(function () {
    const bottomCta = document.querySelector(`.cta-bottom`);
    const buttonCloseCta = document.querySelector(`.js-close-bottom-cta`);

    if (bottomCta) {
        setTimeout(
            () => bottomCta.classList.remove(`cta-bottom--hidden`),
            1000
        );

        buttonCloseCta?.addEventListener(`click`, (evt) => {
            evt.preventDefault();
            document.cookie = `hide_discount_popup=Y; Max-Age=${60 * 60 * 24}; path=/; SameSite=Lax`;
            bottomCta.classList.add(`cta-bottom--hidden`);
        });
    }
})();

// Bottom contacts
(function () {
    const bottomContacts = document.querySelector(`.contacts-bottom`);
    const buttonToggleContacts = document.querySelector(`.js-contacts-toggle-button`);

    if (bottomContacts) {
        buttonToggleContacts?.addEventListener(`click`, (evt) => {
            evt.preventDefault();
            bottomContacts.classList.toggle(`contacts-bottom--opened`);
        });
    }
})();

// All reviews show-hide
(function () {
    const ajaxHandler = '/include/ajax/product_reviews_users.php';

    const showAllReviewsButton = document.querySelector(`.js-show-all-reviews`);
    const allReviewsBlock = document.querySelector(`.users-reviews__all`);
    const allReviewsInner = document.querySelector(`.users-reviews__all-inner`);
    const lastReviewsBlock = document.querySelector(`.users-reviews__slider`);

    if (showAllReviewsButton && allReviewsBlock && lastReviewsBlock) {
        const buttonDefaultText = showAllReviewsButton.textContent;
        const buttonAlternativeText = showAllReviewsButton.dataset.text;

        showAllReviewsButton.addEventListener(`click`, (evt) => {
            evt.preventDefault();

            let userReviewsSection = document.querySelector('.users-reviews');
            if (userReviewsSection) {
                window.scrollTo(0, userReviewsSection.getBoundingClientRect().top + window.pageYOffset);
            }

            if (allReviewsBlock.classList.contains(`users-reviews__all--visible`)) {
                showAllReviewsButton.textContent = buttonDefaultText;

                allReviewsBlock.classList.remove(`users-reviews__all--visible`);
                allReviewsBlock.style.minHeight = "";
                allReviewsBlock.style.maxHeight = "0px";

                lastReviewsBlock.hidden = false;
            } else {
                let minHeight = lastReviewsBlock.offsetHeight;

                let swiperBlock = lastReviewsBlock.querySelector('.swiper');
                if (swiperBlock) {
                    minHeight += parseInt( window.getComputedStyle(swiperBlock).marginBottom );
                }

                showAllReviewsButton.textContent = buttonAlternativeText;

                allReviewsBlock.classList.add(`users-reviews__all--visible`);
                allReviewsBlock.style.minHeight = `${minHeight}px`;

                lastReviewsBlock.hidden = true;

                if (!allReviewsBlock.querySelector('.js-all-reviews-block')) {
                    initAllReviews();
                }
                else {
                    changeReviewsHeight();
                }
            }
        });

        // "Show more reviews" button
        allReviewsBlock.addEventListener('click', (e) => {
            let elem = e.target;
            if (elem.id !== 'js-more-user-reviews') {
                return;
            }

            e.preventDefault();

            if (allReviewsBlock.classList.contains('js-processing')) {
                return;
            }
            allReviewsBlock.classList.add('js-processing');

            let product = elem.dataset.product,
                page = elem.dataset.nextPage;

            elem.parentElement.remove();

            fetch( `${ajaxHandler}?action=show_more&product=${product}&page=${page}`)
                .then((response) => response.text())
                .then((result) => {
                    let reviewsContainer = allReviewsBlock.querySelector('#js-list-user-reviews');
                    reviewsContainer.insertAdjacentHTML('beforeend', result);
                    allReviewsBlock.classList.remove('js-processing');
                    changeReviewsHeight();
                });
        });

        window.addEventListener(`resize`, () => {
            if (allReviewsBlock.classList.contains(`users-reviews__all--visible`)) {
                changeReviewsHeight();
            }
        });
    }

    function initAllReviews() {
        if (allReviewsBlock.classList.contains('js-processing')) {
            return;
        }

        allReviewsBlock.classList.add('js-processing');

        fetch(ajaxHandler + '?action=init&product=' + showAllReviewsButton.dataset.product)
            .then((response) => response.text())
            .then((result) => {
                allReviewsInner.insertAdjacentHTML('beforeend', result);
                allReviewsBlock.classList.remove('js-processing');
                changeReviewsHeight();
            });
    }

    function changeReviewsHeight() {
        allReviewsBlock.style.maxHeight = `${allReviewsInner.offsetHeight}px`;
    }
})();

// Init form labels
const formFields = document.querySelectorAll(`.form__field`);
formFields.forEach((field) => {
    window.form.initLabel(field);
});

// Init users reviews modal
const userReviewItems = document.querySelectorAll(`.review-card`);
userReviewItems.forEach((item) => {
    window.modal.initUsersReviewModal(item);
});

// Init famous reviews modal
const famousReviewItems = document.querySelectorAll(`.review-item`);
famousReviewItems.forEach((item) => {
    window.modal.initFamousReviewModal(item);
});
